export default {
  subCompetencies: [],
  subCompetency: undefined,
};
